import { Button, Group, Modal, Stack, Text } from '@mantine/core';

interface PartnerArchiveModalProps {
  opened: boolean;
  partnerName: string | null | undefined;
  onClose: () => void;
  onConfirm: () => void;
}

export function PartnerArchiveModal({
  opened,
  partnerName,
  onClose,
  onConfirm,
}: Readonly<PartnerArchiveModalProps>) {
  return (
    <Modal opened={opened} onClose={onClose} title="Archive partner">
      <Stack gap="sm">
        <Text size="sm">
          Archive <strong>{partnerName ?? 'this partner'}</strong>? They stop being shortlistable
          and lockable; existing conversations and dispatched work are unaffected. You can restore
          them later (they re-enter as a prospect).
        </Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="red"
            data-testid="np-archive-confirm"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            Archive
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
